import React from 'react';
import Input from './Input.jsx';

export default function NumberInput(props) {
  const handleChange = function (field) {
    if (props.onChange && field.value.match(/^[0-9]*(\.[0-9]*)?$/)) {
      props.onChange({name: field.name, value: field.value});
    }
  };
  return (
    <Input {...props} onChange={handleChange} />
  );
};



// WEBPACK FOOTER //
// ../hyperdb-utils/src/components/ui-react/NumberInput.jsx